import _ from 'lodash-es';
import IMask from 'imask';
import Utils from '~/scripts/services/utils';

const matchInputMask = (
	/** @type {any} */ value,
	/** @type {any} */ inputMask,
) => {
	if (!inputMask || typeof inputMask.mask !== 'function') {
		return true;
	}

	// eslint-disable-next-line eqeqeq
	return inputMask.mask(value) == value;
};

/**
 * @param {import('angular').ITimeoutService} $timeout
 * @returns {any}
 */
const kformInputMaskDirective = /* @ngInject */ $timeout => ({
	restrict: 'A',
	require:  'ngModel',
	scope: {
		maskOptions: '<',
	},
	/**
	 * @param {any} scope
	 * @param {import('angular').IRootElementService} element
	 * @param {import('angular').IAttributes} attributes
	 * @param {import('angular').INgModelController} controller
	 */
	link(scope, element, attributes, controller) {
		const inputElement = element[0].tagName === 'INPUT' ? element[0] : element[0].querySelectorAll('INPUT')[0];
		const language = scope.maskOptions?.language || navigator.language || 'fr';
		const separators = Utils.getNumberSeparators(language);

		scope.radix = scope.maskOptions?.radix || separators.radix || '.';

		scope.thousandsSeparator = scope.maskOptions?.thousandsSeparator || separators.thousandsSeparator || ' ';

		// Allow override of radix and thousandsSeparator in options.
		if (
			scope.maskOptions?.languageOverride
			&& Object.prototype.hasOwnProperty.call(scope.maskOptions?.languageOverride, language)
		) {
			scope.radix = scope.maskOptions?.languageOverride[language].radix;
			scope.thousandsSeparator = scope.maskOptions?.languageOverride[language].thousandsSeparator;
			scope.mapToRadix = ['.', ','];
		}
		scope.radix = '.';

		scope.mapToRadix = ['.', ','];

		const getOptions = () => {
			/** @type {any} */
			const maskOptions = {
				...scope.maskOptions,
				// prefix: '',
				// suffix: '',
				mapToRadix:         scope.mapToRadix,
				thousandsSeparator: _.get(scope.$parent.component, 'thousandsSeparator', scope.thousandsSeparator),
				radix:              _.get(scope.$parent.component, 'decimalSymbol', scope.radix) ?? ',',
				signed:             _.get(scope.$parent.component, 'allowNegative', true),
			};

			// eslint-disable-next-line unicorn/prefer-ternary
			if (_.get(scope.maskOptions, 'scale', scope.scale) === 0
				|| (scope.maskOptions?.validate?.integer)
				|| !_.get(scope.maskOptions, 'allowDecimal', true)
			) {
				maskOptions.scale = 0;
			}
			else {
				maskOptions.scale = _.get(scope.maskOptions, 'scale', scope.scale) ?? 2;
				// maskOptions.requireDecimal = _.get(scope.maskOptions, 'requireDecimal', scope.requireDecimal);
			}

			maskOptions.padFractionalZeros = _.get(scope.maskOptions, 'padFractionalZeros', scope.padFractionalZeros) ?? true;
			maskOptions.normalizeZeros = false;

			maskOptions.mask = scope.maskOptions?.mask ?? scope.maskOptions?.inputMask ?? Number;

			return maskOptions;
		};

		/**
		 * Sets the input mask for an input.
		 *
		 * @param {Element | HTMLElement} input - The html input to apply the mask to.
		 */
		const setInputMask = input => {
			if (!input) {
				// eslint-disable-next-line no-console
				console.warn('no input');
				return;
			}

			const maskOptions = getOptions();

			// Set the mask on the input element.
			if (maskOptions.mask) {
				// @ts-ignore
				scope.inputMask = IMask(input, maskOptions);
			}
		};

		$timeout(() => {
			setInputMask(inputElement);
		});

		controller.$validators.mask = (modelValue, viewValue) => {
			const input = modelValue || viewValue;

			if (input) {
				return matchInputMask(input, scope.inputMask);
			}

			return true;
		};

		// Convert from view to model
		controller.$parsers.push(value => (value ? scope.inputMask.typedValue : value));

		// Convert from model to view
		controller.$formatters.push(value => {
			if (Array.isArray(value)) {
				// eslint-disable-next-line no-param-reassign
				value = value[0];
			}
			try {
				// Strip out the prefix and suffix. scope occurs when numbers are from an old renderer.
				// eslint-disable-next-line no-param-reassign
				value = value.replace(scope.prefix, '').replace(scope.suffix, '');
			}
			catch {
				// If value doesn't have a replace method, continue on as before.
			}

			// If not a number, return empty string.
			if (Number.isNaN(value)) {
				return '';
			}

			// If empty string, zero or other, don't format.
			if (!value) {
				return value;
			}

			return value;
		});

		scope.$watch('options', (/** @type {any} */ newComponent, /** @type {any} */ oldComponent) => {
			if (scope.inputMask && !_.isEqual(newComponent, oldComponent)) {
				const maskOptions = getOptions();
				scope.inputMask.updateOptions(maskOptions);
			}
		}, true);

		scope.$on('$destroy', () => {
			if (scope.inputMask) {
				scope.inputMask.destroy();
				scope.inputMask = undefined;
			}
		});
	},
});

export default kformInputMaskDirective;
